import styled from 'styled-components'

export const Wrapper = styled.div`
  display: flex;
  justify-content: space-between;
  margin-bottom: 12px;

  > div:last-child {
    margin-left: auto;
  }
`

export const ChipContent = styled.div`
  font-size: 14px;
  display: flex;
  gap: 6px;
  align-items: center;
`
